import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
const approaches = [{
  title: 'Enviar el precio de inmediato',
  description: 'Mata la curiosidad y te convierte en un número más en la lista.'
}, {
  title: 'Escribir párrafos eternos',
  description: 'Abruma al cliente y te hace parecer desesperada por la venta.'
}, {
  title: 'Usar diminutivos y excesiva amabilidad',
  description: 'Baja tu estatus profesional a los ojos del comprador.'
}, {
  title: 'No tener un sistema de filtrado',
  description: 'Te obliga a atender a 100 personas para cerrar solo a una (o a ninguna).'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5
    }
  }
};
export function FailedApproaches() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-navy-800 text-text-light relative" data-id="element-12">
      {/* Top divider */}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-gold-500/30 to-transparent" data-id="element-13" />

      <div className="max-w-6xl mx-auto" data-id="element-14">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-15">
          <h2 className="text-3xl sm:text-4xl font-bold mb-4" data-id="element-16">
            Por qué lo que has intentado NO funciona
          </h2>
          <div className="w-24 h-1 bg-gold-500 mx-auto rounded-full" data-id="element-17" />
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid sm:grid-cols-2 gap-6 lg:gap-8" data-id="element-18">
          {approaches.map((item, index) => <motion.div key={index} variants={itemVariants} className="bg-navy-900 p-6 sm:p-8 rounded-xl border border-navy-700 hover:border-gold-500/30 transition-colors duration-300" data-id="element-19">
              <div className="flex items-start gap-4" data-id="element-20">
                <div className="flex-shrink-0 mt-1" data-id="element-21">
                  <XCircle className="w-6 h-6 text-red-400" data-id="element-22" />
                </div>
                <div data-id="element-23">
                  <h3 className="text-xl font-bold text-cream-50 mb-2 font-sans" data-id="element-24">
                    {item.title}
                  </h3>
                  <p className="text-cream-100/70 leading-relaxed" data-id="element-25">
                    {item.description}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </motion.div>
      </div>

      {/* Bottom divider */}
      <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-gold-500/30 to-transparent" data-id="element-26" />
    </section>;
}